<mdb-badge 
    [ngClass]="{ 'primary-color-dark': vm.type == 'info', 'success-color-dark': vm.type == 'success', 'warning-color-dark': vm.type == 'warning', 'danger-color-dark': vm.type == 'danger' }" 
    class="px-2" pill="true" mdbWavesEffect>{{vm.title}}</mdb-badge>
